(function(){
  "use strict";
  function initApp(DATA){
  var FORM_FACTORS = DATA.form_factors;
  var INDUSTRIES = DATA.industries;
  var MATERIALS = DATA.materials;
  var DEVICES = {};
  DATA.devices.forEach(function(d){ DEVICES[d.name] = d; });

  var FF_META = {
    "Advanced Benchtop Devices for Color Lab and Quality Control Stations": {
      short: "Benchtop — Lab & QC",
      desc: "Fixed installation in a color lab or QC station.",
      icon: 'bench',
      image: "https://cdn.shopify.com/s/files/1/0822/7300/9979/files/Color_Laboratory.jpg?v=1788774402"
    },
    "Multipurpose portable devices for Color Lab, Quality Control Station and field usage": {
      short: "Portable — Multipurpose",
      desc: "Moves between the lab, the QC station and the field.",
      icon: 'portable',
      image: "https://cdn.shopify.com/s/files/1/0822/7300/9979/files/Lab_Fileld.jpg?v=1788774450"
    },
    "Mobile devices suited mostly for field usage": {
      short: "Mobile — Field",
      desc: "Lightweight, pocketable, built mainly for on-site work.",
      icon: 'mobile',
      image: "https://cdn.shopify.com/s/files/1/0822/7300/9979/files/Quality_Control.jpg?v=1788774420"
    }
  };

  // Display order for the form-factor cards (independent of the data's own array order):
  // Benchtop, then Portable — Multipurpose, then Mobile — Field.
  var FF_DISPLAY_ORDER = [
    "Advanced Benchtop Devices for Color Lab and Quality Control Stations",
    "Multipurpose portable devices for Color Lab, Quality Control Station and field usage",
    "Mobile devices suited mostly for field usage"
  ];

  var ICONS = {
    bench: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="8" width="18" height="10" rx="1.5"/><path d="M7 8V6a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2"/><circle cx="8.5" cy="13" r="1.4"/><path d="M12.5 12h5M12.5 14.5h5"/></svg>',
    portable: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="6" y="2" width="12" height="20" rx="2.5"/><circle cx="12" cy="8" r="2.3"/><path d="M9 15h6M9 18h4"/></svg>',
    mobile: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="7" y="3" width="10" height="18" rx="2.5"/><circle cx="12" cy="16.4" r="1.3"/><path d="M10 6.5h4"/></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>',
    warn: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>',
    arrow: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>',
    search: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>',
    empty: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>'
  };

  var state = { formFactors: new Set(), industry: '', sub: '', materialId: null, search: '' };

  /* ---------- STEP 1 : form factors ---------- */
  var ffGrid = document.getElementById('ffGrid');
  var FORM_FACTORS_DISPLAY = FF_DISPLAY_ORDER.filter(function(ff){ return FORM_FACTORS.indexOf(ff) !== -1; });
  FORM_FACTORS.forEach(function(ff){ if (FORM_FACTORS_DISPLAY.indexOf(ff) === -1) FORM_FACTORS_DISPLAY.push(ff); });

  FORM_FACTORS_DISPLAY.forEach(function(ff, i){
    var meta = FF_META[ff] || { short: ff, desc: '', icon: 'portable' };
    var id = 'ff' + i;
    var label = document.createElement('label');
    label.className = 'ff-card';
    label.innerHTML =
      (meta.image ? '<span class="ff-image"><img src="' + meta.image + '" alt="" loading="lazy"></span>' : '') +
      '<span class="ff-content">' +
        '<input type="checkbox" id="' + id + '" value="' + i + '">' +
        '<span class="ff-check">' + ICONS.check + '</span>' +
        '<span class="ff-label">' + meta.short + '</span>' +
        '<span class="ff-desc">' + meta.desc + '</span>' +
      '</span>';
    ffGrid.appendChild(label);
    label.querySelector('input').addEventListener('change', function(e){
      if (e.target.checked) state.formFactors.add(ff); else state.formFactors.delete(ff);
      document.getElementById('ffError').classList.remove('show');
      renderResults();
      // Only jump to results if a material is already picked — otherwise the customer
      // is still working through step 1 and hasn't asked to see results yet.
      if (state.materialId != null) scrollToResults();
    });
  });

  /* ---------- STEP 2 : industry ---------- */
  var industrySelect = document.getElementById('industrySelect');
  Object.keys(INDUSTRIES).forEach(function(ind){
    var opt = document.createElement('option');
    opt.value = ind; opt.textContent = ind;
    industrySelect.appendChild(opt);
  });

  var subSelect = document.getElementById('subSelect');
  var colSub = document.getElementById('colSub');
  var colMaterial = document.getElementById('colMaterial');
  var materialSearch = document.getElementById('materialSearch');
  var materialList = document.getElementById('materialList');
  var materialCount = document.getElementById('materialCount');

  industrySelect.addEventListener('change', function(){
    state.industry = industrySelect.value;
    state.sub = ''; state.materialId = null; state.search = '';
    materialSearch.value = '';
    subSelect.innerHTML = '<option value="">All sub-industries</option>';
    if (state.industry){
      INDUSTRIES[state.industry].forEach(function(sub){
        var opt = document.createElement('option');
        opt.value = sub; opt.textContent = sub;
        subSelect.appendChild(opt);
      });
      colSub.classList.remove('disabled'); subSelect.disabled = false;
      colMaterial.classList.remove('disabled'); materialSearch.disabled = false;
    } else {
      colSub.classList.add('disabled'); subSelect.disabled = true;
      colMaterial.classList.add('disabled'); materialSearch.disabled = true;
    }
    renderMaterialList();
    renderResults();
  });

  subSelect.addEventListener('change', function(){
    state.sub = subSelect.value; state.materialId = null;
    renderMaterialList();
    renderResults();
  });

  materialSearch.addEventListener('input', function(){
    state.search = materialSearch.value.trim().toLowerCase();
    renderMaterialList();
  });

  function currentMaterials(){
    if (!state.industry) return [];
    return MATERIALS.filter(function(mat){
      if (mat.main_industry !== state.industry) return false;
      if (state.sub && mat.sub_industry !== state.sub) return false;
      if (state.search && mat.name.toLowerCase().indexOf(state.search) === -1) return false;
      return true;
    });
  }

  function renderMaterialList(){
    var list = currentMaterials();
    materialCount.textContent = state.industry ? (list.length + (list.length === 1 ? ' item' : ' items')) : '';
    materialList.innerHTML = '';
    if (!state.industry){
      return;
    }
    if (list.length === 0){
      materialList.innerHTML = '<li class="material-empty">No materials match your search.</li>';
      return;
    }
    list.forEach(function(mat){
      var li = document.createElement('li');
      li.className = 'material-item' + (mat.id === state.materialId ? ' active' : '');
      li.textContent = mat.name;
      li.setAttribute('role', 'option');
      li.tabIndex = 0;
      li.addEventListener('click', function(){
        state.materialId = mat.id;
        renderMaterialList();
        renderResults();
        scrollToResults();
      });
      li.addEventListener('keydown', function(e){
        if (e.key === 'Enter' || e.key === ' '){ e.preventDefault(); li.click(); }
      });
      materialList.appendChild(li);
    });
  }
  renderMaterialList();

  /* ---------- RESULTS ---------- */
  var ATTR_LABELS = {
    optical: 'Optical', form: 'Form', uniformity: 'Uniformity', effects: 'Effects', texture: 'Texture'
  };

  function deviceIconFor(formFactor){
    var meta = FF_META[formFactor];
    return ICONS[meta ? meta.icon : 'portable'];
  }

  function scrollToResults(){
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var el = document.getElementById('results');
    if (!el) return;
    // Wait a frame so the freshly-rendered result content has been laid out before we measure/scroll to it.
    window.requestAnimationFrame(function(){
      el.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    });
  }

  function renderResults(){
    var body = document.getElementById('resultsBody');
    var mat = state.materialId != null ? MATERIALS[state.materialId] : null;

    if (!mat){
      body.innerHTML =
        '<div class="placeholder-state">' + ICONS.empty +
        '<h3>No material selected yet</h3>' +
        '<p>Complete steps 1 and 2 above and your recommended devices will appear here.</p></div>';
      return;
    }

    var ffOk = state.formFactors.size > 0;
    var matched = ffOk ? mat.compatible_devices.filter(function(cd){ return state.formFactors.has(cd.form_factor); }) : [];

    var html = '';
    html += '<div class="material-card">' +
      '<div class="material-card-name">' + mat.name +
      '<span class="material-card-path">' + mat.main_industry + ' → ' + mat.sub_industry + '</span></div>' +
      '<div class="attr-chips">' +
        chip('optical', mat.optical) + chip('form', mat.form) + chip('uniformity', mat.uniformity) +
        chip('effects', mat.effects.replace(' (pearlescent, iridescent)','')) + chip('texture', mat.texture) +
      '</div></div>';

    if (!ffOk){
      html += '<div class="empty-state">' + ICONS.warn +
        '<h3>Choose a form factor first</h3>' +
        '<p>Go back to step 1 and select at least one form factor to see matching devices for this material.</p></div>';
    } else if (matched.length === 0){
      html += '<div class="empty-state">' + ICONS.warn +
        '<h3>No exact match in the selected form factor(s)</h3>' +
        '<p>None of the Ametra devices in your selected setting(s) are specified for this exact combination of ' +
        'appearance, form, uniformity, effect and texture. Try adding another form factor, or reach out — ' +
        'our applications team can advise on the closest fit.</p>' +
        '<a class="cta" href="https://ametra.ai/contact" target="_blank" rel="noopener">Talk to Ametra</a></div>';
    } else {
      html += '<div class="device-grid">';
      matched.forEach(function(cd){
        var dev = DEVICES[cd.device];
        var notesHtml = cd.notes.length ? '<div class="device-notes">' + cd.notes.map(function(n){
          return '<div class="device-note">' + ICONS.warn + '<span><b>' + n.dimension + ':</b> ' + n.caveat + '</span></div>';
        }).join('') + '</div>' : '';
        var photoHtml = dev.photo ?
          '<img src="' + dev.photo + '" alt="' + dev.name + '" loading="lazy" ' +
          'onerror="this.style.display=\'none\';this.nextElementSibling.style.display=\'flex\';">' +
          '<span class="fallback-icon">' + deviceIconFor(dev.form_factor) + '</span>'
          : '<span class="fallback-icon" style="display:flex;">' + deviceIconFor(dev.form_factor) + '</span>';
        html += '<div class="device-card">' +
          '<div class="device-photo"><span class="ff-badge">' + (FF_META[dev.form_factor] || {}).short + '</span>' + photoHtml + '</div>' +
          '<div class="device-body">' +
            '<div class="device-name">' + dev.name + '</div>' +
            '<div class="device-desc">' + dev.description + '</div>' +
            notesHtml +
            '<a class="device-link" href="' + dev.url + '" target="_blank" rel="noopener">View product page ' + ICONS.arrow + '</a>' +
          '</div></div>';
      });
      html += '</div>';
    }

    body.innerHTML = html;
  }

  function chip(key, value){
    return '<div class="attr-chip"><span class="attr-chip-label">' + ATTR_LABELS[key] + '</span><span class="attr-chip-value">' + value + '</span></div>';
  }

  renderResults();
  } /* end initApp */

  /* Dual data-loading mode:
     - Single-file build (Artifact / standalone HTML): data is inlined in #ametra-data.
     - Shopify build: window.AMETRA_DATA_URL points at the assets/*.json file; fetch it. */
  if (window.AMETRA_DATA_URL) {
    fetch(window.AMETRA_DATA_URL, { credentials: 'omit' })
      .then(function(r){ if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(initApp)
      .catch(function(err){
        console.error('Ametra device selector: failed to load data.json', err);
        var body = document.getElementById('resultsBody');
        if (body) {
          body.innerHTML = '<div class="empty-state"><h3>Could not load device data</h3>' +
            '<p>The data file failed to load. Please refresh the page, or contact us if the problem continues.</p></div>';
        }
      });
  } else {
    var inlineEl = document.getElementById('ametra-data');
    if (inlineEl) { initApp(JSON.parse(inlineEl.textContent)); }
  }
})();
